var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PopupLayer',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('v-date-picker',{staticStyle:{"max-width":"480px"},attrs:{"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }